import { useIntl } from "react-intl";
import { useGetPackingListConfig } from "api/queries/location/useGetPackingListConfig";
import InputDropdownGroup from "components/v2/InputDropdownGroup/InputDropdownGroup";
import { capitalizeFirstLetter } from "helpers/commonHelpers";
import {
  unitMeasurementCmOrInch,
  unitMeasurementKgOrLbs,
} from "pages/shipper/RequestForm/components/PackingList/PackingListDefaultOptions";

interface PackingListMeasurementsFormProps {
  index: number;
  paymentLocationReferenceNumber?: string;
}

const capitalizeWeightUnitLabel = (label: string) =>
  label.split(" ").length > 1 ? capitalizeFirstLetter(label.toLowerCase()) : label.toLowerCase();

export default function PackingListMeasurementsForm({
  index,
  paymentLocationReferenceNumber,
}: PackingListMeasurementsFormProps) {
  const intl = useIntl();

  const { data: packingListConfig }: any = useGetPackingListConfig(paymentLocationReferenceNumber!, {
    enabled: !!paymentLocationReferenceNumber,
  });

  const handlingUnitOptions = packingListConfig?.handling_unit_options?.map((handlingUnit: any) => ({
    label: capitalizeFirstLetter(handlingUnit[Object.keys(handlingUnit)[0]].label),
    value: handlingUnit[Object.keys(handlingUnit)[0]].label,
  }));

  return (
    <div className="d-flex flex-column gap-xl mr-3xl">
      <InputDropdownGroup
        width="fit-content"
        label={intl.formatMessage({
          id: "documentParser.uploadPage.reviewDrawer.numberOfUnits",
          defaultMessage: "Number of units",
        })}
        names={[`packing_list.${index}.units`]}
        inputPlaceholders={["Units"]}
        dropdownName={`packing_list.${index}.handling_unit`}
        options={handlingUnitOptions || []}
      />

      <div className="d-flex gap-xl">
        <InputDropdownGroup
          label={intl.formatMessage({
            id: "documentParser.uploadPage.reviewDrawer.weightPerUnit",
            defaultMessage: "Weight per unit",
          })}
          names={[`packing_list.${index}.weight_piece`]}
          inputPlaceholders={["Weight"]}
          dropdownName={`packing_list.${index}.w_unit`}
          options={unitMeasurementKgOrLbs(intl).map((option) => ({
            ...option,
            label: capitalizeWeightUnitLabel(option.label),
          }))}
        />

        <InputDropdownGroup
          label={intl.formatMessage({
            id: "documentParser.uploadPage.reviewDrawer.dimensionsOfUnits",
            defaultMessage: "Dimensions of units",
          })}
          names={[`packing_list.${index}.length`, `packing_list.${index}.width`, `packing_list.${index}.height`]}
          inputPlaceholders={["L", "W", "H"]}
          dropdownName={`packing_list.${index}.m_unit`}
          options={unitMeasurementCmOrInch(intl).map((option) => ({ ...option, label: option.label.toLowerCase() }))}
        />
      </div>
    </div>
  );
}

PackingListMeasurementsForm.defaultProps = {
  paymentLocationReferenceNumber: undefined,
};
